import { Box, Card, Skeleton } from "@mui/material";

const ComparisonSkeleton = () => (
  <Box sx={{ px: 3, pb: 4 }}>
    {/* Strategy cards */}
    <Box display="flex" gap={2} mb={3} flexWrap="wrap">
      {[0, 1].map((cardIndex) => (
        <Card key={cardIndex} sx={{ p: 3, flex: 1, borderRadius: 2 }}>
          <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
            <Skeleton width={90} height={20} />
            {cardIndex === 1 && <Skeleton variant="rounded" width={200} height={40} />}
          </Box>
          <Skeleton width="55%" height={36} sx={{ mb: 0.5 }} />
          <Skeleton width="90%" height={16} />
          <Skeleton width="75%" height={16} sx={{ mb: 2 }} />
          <Box display="flex" gap={1}>
            <Skeleton variant="rounded" width={60} height={26} sx={{ borderRadius: 4 }} />
            <Skeleton variant="rounded" width={80} height={26} sx={{ borderRadius: 4 }} />
            <Skeleton variant="rounded" width={70} height={26} sx={{ borderRadius: 4 }} />
          </Box>
        </Card>
      ))}
    </Box>

    {/* Comparison summary */}
    <Box mb={3}>
      <Card sx={{ p: 3, py: 5, borderRadius: 2 }}>
        <Box display="flex" alignItems="flex-start" gap={2}>
          <Skeleton variant="rounded" width={48} height={48} sx={{ borderRadius: 2, flexShrink: 0 }} />
          <Box flex={1}>
            <Skeleton width={200} height={32} sx={{ mb: 1 }} />
            <Skeleton width="65%" height={20} sx={{ mb: 2 }} />
            <Box display="flex" gap={3} flexWrap="wrap">
              <Skeleton width={110} height={20} />
              <Skeleton width={130} height={20} />
              <Skeleton width={120} height={20} />
            </Box>
          </Box>
        </Box>
      </Card>
    </Box>

    {/* Performance table */}
    <Card sx={{ p: 3, borderRadius: 2, mb: 3 }}>
      <Skeleton width={260} height={20} sx={{ mb: 2 }} />
      <Box sx={{ overflowX: "auto" }}>
        <Box display="flex" gap={1.5} mb={1}>
          {[140, 110, 110, 110, 110, 110, 110, 110].map((width, columnIndex) => (
            <Skeleton key={columnIndex} width={width} height={36} />
          ))}
        </Box>
        {[0, 1].map((rowIndex) => (
          <Box key={rowIndex} display="flex" gap={1.5} mb={1}>
            {[140, 110, 110, 110, 110, 110, 110, 110].map((width, columnIndex) => (
              <Skeleton key={columnIndex} width={width} height={44} />
            ))}
          </Box>
        ))}
      </Box>
    </Card>

    {/* Performance chart */}
    <Card sx={{ p: 3, borderRadius: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Skeleton width={220} height={24} />
        <Box display="flex" gap={2} alignItems="center">
          <Skeleton variant="rounded" width={90} height={36} />
          <Skeleton variant="rounded" width={130} height={36} />
        </Box>
      </Box>
      <Skeleton variant="rounded" width="100%" height={700} />
    </Card>
  </Box>
);

export default ComparisonSkeleton;
